module.exports = __webpack_public_path__ + "assets/img/1_1539_big.0a17a2ed.jpg";